export default __webpack_public_path__ + "static/media/breakfast4.5fd2ec59.png";